import { combineReducers } from 'redux';

import { SettingsActions } from '../actions/consts';
import { KYCSettings } from '../models/settings';

type KYCState = {
  loading: boolean;
  errorMessage: string;
  onboarded: boolean,
  data: any;
  cleanedData: KYCSettings;
}

export function kyc(state = { loading: false, errorMessage: '' } as KYCState, action) {
  switch (action.type) {
    case SettingsActions.LOAD_KYC_REQUEST:
      return {
        ...state,
        loading: true,
        errorMessage: '',
        onboarded: false,
        data: null,
        cleanedData: null,
      };
    case SettingsActions.LOAD_KYC_SUCCESS:
    case SettingsActions.SAVE_KYC_SUCCESS:
      console.log(action);
      const data = action.data.kyc || {};
      const message = action.type === SettingsActions.SAVE_KYC_SUCCESS ? 'Changes were successfully saved.' : '';
      return {
        ...state,
        loading: false,
        errorMessage: message,
        onboarded: action.data.onboarded,
        data: data,
        cleanedData: {
          dbaName: data.legal_name,
          einNumber: data.TIN,
          file: data.documents && data.documents['AOI'],
          acceptedTerms: data.tos_acceptance_date,
          acceptedAgreement: data.financial_acceptance_date,
        },
      };
    case SettingsActions.LOAD_KYC_ERROR:
      return {
        ...state,
        loading: false,
        errorMessage: action.error.errorMessage,
      };
    // case SettingsActions.SAVE_KYC_SUCCESS:
    //   return {
    //     ...state,
    //     loading: false,
    //     errorMessage: '',
    //   };
    case SettingsActions.SAVE_KYC_ERROR:
      return {
        ...state,
        loading: false,
        errorMessage: action.error.errorMessage,
      };
    default:
      return state;
  }
}


export const settings = combineReducers({
  kyc,
});
